<template>

  <div class="out-container">
    <div class="mycontainer">
      <h2>Please input your email, and get your api key</h2>
      <el-form :model="form" label-width="120px" label-position	="top">
        <!--  输入邮箱，获取apiKey  -->
        <el-form-item label="your email" prop="email" :rules="rules">
          <el-input v-model="form.email" size="large" name="email" v-loading="loading"	placeholder="please input your email address" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getApiKey" :disabled="loading">Get API Key</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!--   操作步骤   -->

    <div id="features" class="container-fluid">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <div class="row-title">How to get your API ?</div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-4 col-md-4" v-for="(item,key) in details">
            <div :class="item.isActive?'mfeature-box active':'mfeature-box'">
              <div class="mfeature-icon" >
                <div class="icon-bg"><img :src="item.image" alt=""></div>
                <i class="fa fa-comments-o"></i>
              </div>
              <div class="mfeature-title">{{item.title}}</div>
              <div class="mfeature-details">{{item.description}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

<!--    <div id="features" class="container-fluid">-->
<!--      <div class="container">-->
<!--        <div class="row">-->
<!--          <div class="col-md-12">-->
<!--            <div class="row-title">How to get your API ?</div>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="row">-->
<!--          <div class="col-sm-4 col-md-4">-->
<!--            <div class="mfeature-box " >-->
<!--              <div class="mfeature-icon">-->
<!--                <div class="icon-bg"><img src="../static/picture/step3.png" alt=""></div>-->
<!--                <i class="fa fa-star"></i>-->
<!--              </div>-->
<!--              <div class="mfeature-title">1.Input your email address</div>-->
<!--              <div class="mfeature-details">Please check your email address, if you do not receive the email, you can click the send link again</div>-->
<!--            </div>-->

<!--          </div>-->
<!--          <div class="col-sm-4 col-md-4">-->
<!--            <div class="mfeature-box">-->
<!--              <div class="mfeature-icon">-->
<!--                <div class="icon-bg"><img src="../static/picture/step3.png" alt=""></div>-->
<!--                <i class="fa fa-ticket"></i>-->
<!--              </div>-->
<!--              <div class="mfeature-title">2. Open your mail</div>-->
<!--              <div class="mfeature-details">We send you an email with the title "your apikey".</div>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="col-sm-4 col-md-4">-->
<!--            <div class="mfeature-box">-->
<!--              <div class="mfeature-icon" >-->
<!--                <div class="icon-bg"><img src="../static/picture/step3.png" alt=""></div>-->
<!--                <i class="fa fa-comments-o"></i>-->
<!--              </div>-->
<!--              <div class="mfeature-title">3. Copy the apikey </div>-->
<!--              <div class="mfeature-details">Copy the apikey from the email and fill it on your plugin.</div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->

  </div>

</template>


<script>
import {ref} from 'vue'
import {ElMessage} from 'element-plus'
import validateUtil from "@/util/validateUtil";
import tools from "@/util/Tools";
import myapi from '../util/api'
import messageUtil from '../util/messageUtil'
import pic1 from '@/assets/picture/steps/qrcode/1-input.jpg'
import pic2 from '@/assets/picture/steps/qrcode/2-copy-apikey.jpg'
import pic3 from '@/assets/picture/steps/qrcode/3-validate.jpg'

export default {
    setup(){

      // 这里讲form使用ref包裹，进行响应式数据展示；如果不使用ref，输入框不能输入
      const form = ref({

      })

      let loading = ref(false);

      // 介绍内容
      const details=[{
        title:"1.Input your email address",
        description:"Please check your email address, if you do not receive the email, you can click the send link again",
        isActive: false,
        image: pic1
      },{
        title:"2. Copy the apikey",
        description:"Copy the apikey from the email and fill it on your plugin.",
        isActive: false,
        image: pic2
      },{
        title:"3. Validate your apikey",
        description:"Validate your apikey and recharge it.",
        isActive: false,
        image: pic3
      }]

      // 邮箱使用的验证规则
      const rules = [
        {
          required: true,
          message: 'Please input email address',
          trigger: 'blur',
        },
        {
          type: 'email',
          message: 'Please input correct email address',
          trigger: ['blur'],
        },
      ];

      /**
       * 获取动态图片地址
       * @param imageName
       * @returns {*}
       */
      function getImageUrl(imageName){
        return require(imageName);
      }

      /**
       * 请求后端，获取apiKey
       */
      async function getApiKey(){
        // 获取form表单中的数据值
        let email = form.value.email;
        console.log("form:",form.value.email)
        if(!validateUtil.isEmail(email)){
          ElMessage.error('Please input correct email address')
          return ;
        }

        let params = {
          email
        }

        // 封装3
        loading.value = true;
        let resp = await myapi.registerQrCode(params);
        loading.value = false;
        if(!resp){
          return;
        }

        // 非成功场景，框架会提示
        if(tools.isSuccResp(resp)){
          messageUtil.successMsg("We have sent a message to your email, please check your email");
          return ;
        }

      }


      // 可能无法再setup中，引用挂载的proxy的属性
      // 参照地址： https://www.jianshu.com/p/f8b14062337a
      // https://blog.csdn.net/Lschange/article/details/112314580
      return {form,getApiKey,rules,loading,details,getImageUrl}
    },

}
</script>

<style scoped>

.out-container{
  background-color: #f9fbff;
  width: 100%;
}
.mycontainer{
  padding: 30px;
  text-align: center;
  /*border: solid 1px var(--el-border-color);*/
  display: inline-block;
  width: 50%;
  box-sizing: border-box;
  margin: 10px auto;
  vertical-align: top;
  border-radius: 5px;

}
</style>
